<template>
    <div class="f-icon-edit" @click="edit">
        <img class="f-icon-edit-img" :src="icon">
        <span class="f-icon-edit-word">编辑</span>
    </div>
</template>

<style lang="less">
    @import '../../../../assets/less/views/topic-content/icon/edit-icon.less';
</style>

<script>
export default {
    data() {
        return {
            icon: require('@/assets/images/icon-topic/edit.png')
        };
    },
    methods: {
        edit() {
            this.$emit('edit');
        }
    }
};
</script>
